export default __webpack_public_path__ + "static/media/durvis-20-min.05c28254.jpg";